<template>
  <div id="home">
    <h1 style="font-size:40px;font-family:'ヒラギノ角ゴ ProN';color:#FFF;padding-top:60px;">
    <!-- <h1 style="font-size:40px;font-family:'ヒラギノ角ゴ ProN';color:#222288;padding-top:60px;text-stroke: 0.8px #EEEEFF;"> -->
      <b><span style="display: inline-block;">レジスタンス</span> <span style="display: inline-block;">オンライン</span></b></h1>

      <div class="my-10">
        <startGameCard
          v-show="selected=='start'"
          :selected="selected"
          :userName="userName"
          :roomId="roomId"
          :roomIdFixed="roomIdFixed"
          v-on:select-mode="menuSelected"
        />
        <descriptionCard v-show="selected=='description'" :selected="selected" v-on:select-mode="menuSelected" />
        <versionRecordCard v-show="selected=='version'" :selected="selected" v-on:select-mode="menuSelected" />
        <reportCard v-show="selected=='report'" :selected="selected" v-on:select-mode="menuSelected" />

        <startGameCard
          v-show="selected!='start'"
          :selected="selected"
          :userName="userName"
          :roomId="roomId"
          :roomIdFixed="roomIdFixed"
          v-on:select-mode="menuSelected"
        />
        <descriptionCard v-show="selected!='description'" :selected="selected" v-on:select-mode="menuSelected" />
        <versionRecordCard v-show="selected!='version'" :selected="selected" v-on:select-mode="menuSelected" />
        <reportCard v-show="selected!='report'" :selected="selected" v-on:select-mode="menuSelected" />
      </div>

  </div>
</template>
<script>
import startGameCard from "@/components/homeComponents/StartCard.vue"
import descriptionCard from "@/components/homeComponents/GameDescription.vue"
import versionRecordCard from "@/components/homeComponents/VersionRecord.vue"
import reportCard from "@/components/homeComponents/ReportCard.vue"
export default {
  name: 'home',
  props: ['room'],
  components: {
    startGameCard,
    descriptionCard,
    versionRecordCard,
    reportCard,
  },
  data (){
    return {
      roomId: '',
      roomIdFixed: false,
      userName: '',
      selected: 'start',
      userId: null,
      buttonMode: 'join',
    };
  },
  computed: {
  },
  methods: {
    menuSelected (payload) {
      this.selected = payload.selected
    },
  },
  created: function() {
    // this.userName = Math.random().toString(32).substring(5)
    // this.roomId = "1234"
    if (this.room){
      this.roomId = this.room
      this.roomIdFixed = true
    }
  }
}
</script>

<style>
#home {
  position: relative; /*相対位置*/
  background-image: url("~@/assets/background.jpg");
  background-size: auto;
  background-attachment: fixed;
  /* Full height */
  height: 100%;
  /* Center and scale the image nicely */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  /* width: 20% */
}
/* #home .title {
} */
#home .name-input-box {
  /* padding-top: 12px; */
  /* background-color: #FFFFFF; */
}
#home .room-input-box {
  /* margin-top: -10px; */
  /* background-color: #FFFFFF; */
}
#home .start-card {
  margin: 40px auto;
}
#home .send-button {
  margin-bottom: 16px;
}
#home .input-field {
  width: 200px;
  text-align: center;
  margin: 0 auto;
  /* padding-top:12px; */
}
.home-background-color {
  background-color: #EEEEFF
}
.text-area {
  width: 200px;
  text-align: center;
  margin: 0 auto;
}
.centered-input {
  margin: 0 auto;
}
.input-form {
  padding-top: 12px;
  padding-bottom: 12px;
  padding-left: 12px;
  padding-right: 12px;
}
</style>
